
<template>
  <v-app id="app" :style="{'backgroundImage': 'url(' + this.backgroundImage + ')'}">
    <router-view v-if="!loading"></router-view>
    <support :id="user.id"/>
    <upgrade-modal />
  </v-app>
</template>
<script type="text/javascript">
import AuthUser from "@/services/api/authUser";
import support from "@/components/support";
import upgradeModal from "@/components/upgradeModal";
import getSubdomain from "@/services/api/subDomains";

export default {
  components: { support, upgradeModal },
  data() {
    return {
      user: AuthUser,
      company: {},
      loading: true,
      backgroundImage: "/img/beach.jpg"
    };
  },
  mounted() {
    getSubdomain()
      .then(subdomain => {
        if (subdomain.background_image) {
          this.backgroundImage = subdomain.background_image || "/img/beach.jpg";
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang='less'>
@import "./styles/buttons";
@import "./styles/cards";
@import "./styles/main";

#app {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
</style>
